import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles(theme => ({
  until: {
    marginLeft: theme.spacing(2)
  }
}))

export {
  useStyles
}